import { useEffect, useMemo } from "react";

import { AccountContext } from "views/AccountWrapper";
import useTypedContext from "hooks/useTypedContext";
import { Space } from "types/generated";
import NotFoundPage from "components/error/NotFoundPage";
import { SpacesContext } from "views/Account/SpacesProvider";

import PersonalSettingsSpacesPageLayout from "./PageLayout";
import PersonalSettingsSpacesEmpty from "./Empty";
import usePersonalSettingsSpacesTableGroupsStore from "./Table/usePersonalSettingsSpacesGroupsStore";
import PersonalSettingsSpacesTable from "./Table";

const PersonalSettingsSpaces = () => {
  const { viewer } = useTypedContext(AccountContext);
  const { spaces } = useTypedContext(SpacesContext);

  const spacesById = useMemo(
    () =>
      spaces.reduce((acc, space) => ({ ...acc, [space.id]: space }), {} as Record<string, Space>),
    [spaces]
  );

  const spaceActions = useMemo(
    () =>
      viewer?.actions.map((action) => ({
        ...action,
        id: action.spaceID,
        spaceName: spacesById[action.spaceID]?.name,
        actions: action.actions.map((actionId) => ({
          id: `${action.spaceID}-${actionId}`,
          actionID: actionId,
          spaceID: action.spaceID,
        })),
      })),
    [viewer?.actions, spacesById]
  );

  const { initializeStore } = usePersonalSettingsSpacesTableGroupsStore();

  useEffect(() => {
    initializeStore(spaceActions);
  }, [initializeStore, spaceActions]);

  if (!viewer?.actions) {
    return <NotFoundPage />;
  }

  return (
    <PersonalSettingsSpacesPageLayout>
      {viewer.actions.length === 0 && <PersonalSettingsSpacesEmpty />}
      {viewer.actions.length > 0 && <PersonalSettingsSpacesTable />}
    </PersonalSettingsSpacesPageLayout>
  );
};

export default PersonalSettingsSpaces;
